<template>
  <div class="greetings-view">
    <div class="greetings-view-wrapper">
      <div class="greetings-view__logo fade-in-1000ms">
        <div class="greetings-view__logo-img">
          <img src="./assets/logo-like.svg">
        </div>
        <div class="greetings-view__logo-text">
          Like Центр
        </div>
      </div>
      <div class="greetings-view-section greetings-view__banner fade-in-1000ms">
        <div class="greetings-view__banner-background" />
        <img
          class="greetings-view__banner-stars-img"
          src="./assets/banner-stars.svg"
        >
        <img
          v-if="$size.width > 500"
          class="greetings-view__banner-ship-img"
          src="./assets/banner-ship.svg"
        >
        <img
          v-else
          class="greetings-view__banner-ship-img"
          src="./assets/banner-ship-sm.svg"
        >
        <div class="greetings-view__banner-text">
          <div class="greetings-view__banner-text-title">
            ДОБРО ПОЖАЛОВАТЬ
          </div>
          <div class="greetings-view__banner-text-description">
            Впереди у тебя два насыщенных года и программа, 
            которая поможет кратно вырасти в прибыли и масштабировать бизнес.
          </div>
        </div>
      </div>
      <div 
        class="
          greetings-view-section
          greetings-view__info-section
          greetings-view__summary-section
          fade-in-1000ms
        "
      >
        <div class="greetings-view__summary-section-text greetings-view__title">
          Скоро с тобой свяжется <span class="red-text">сервис-менеджер</span> 
          и детально введет в курс дела!
          <br>
          <br v-if="$size.width < 700">
          А пока изучи краткую информацию о том, что тебя ждет.
        </div>
      </div>
      <div 
        class="
          greetings-view-section
          greetings-view__info-section
          greetings-view__study-map-section
          fade-in-1000ms
        "
      >
        <div class="greetings-view__study-map-section-text">
          <div class="greetings-view__study-map-section-text-title greetings-view__title">
            Карта твоего обучения
          </div>
          <div class="greetings-view__description">
            Создание и развитие бизнеса в <span class="red-text">Like Центре</span> — как игра. 
            Проходишь один уровень обучения — открывается другой ;)
            <br><br>
            Только вместо баллов зарабатываешь настоящие деньги. 
            И на всём пути тебе помогает опытный наставник!
            <br><br>
            Обучение проходит в простой и понятной форме. 
            Все материалы адаптированы под уровень студента.
            <br><br>
            Читай описание модулей программы: каждый из них поможет тебе 
            получить полезные навыки и построить успешный бизнес.
          </div>
        </div>
        <div class="greetings-view__study-map-section-img">
          <img
            loading="lazy"
            src="./assets/study-map.png"
          >
        </div>
      </div>
      <div 
        class="
          greetings-view-section 
          greetings-view__info-section 
          greetings-view__materials-section
        "
      >
        <div class="greetings-view__materials-section-img">
          <img
            loading="lazy"
            src="./assets/materials.png"
          >
        </div>
        <div class="greetings-view__materials-section-text">
          <div class="greetings-view__materials-section-text-title greetings-view__title">
            Образовательная платформа <span class="indigo-text">TOOLBOX</span>
          </div>
          <div class="greetings-view__description">
            Все необходимые материалы и трекинг твоих результатов 
            будут доступны на нашей платформе. 
            <br><br>
            Сразу после регистрации откроются блоки:
            <ul class="greetings-view__description-list">
              <li>«Предобучение»</li>
              <li>Вводные уроки для твоего потока</li>
              <li>Папки «Сборные»</li>
            </ul>
          </div>
        </div>
      </div>
      <div 
        class="
          greetings-view-section
          greetings-view__info-section
          greetings-view__tasks-section
        "
      >
        <div class="greetings-view__tasks-section-title greetings-view__title">
          Сейчас тебе необходимо:
        </div>
        <div class="greetings-view__tasks-section-task-cards">
          <div
            v-for="(item, index) in taskCards"
            :key="index"
            class="greetings-view__tasks-section-task-card"
          >
            <div class="greetings-view__tasks-section-task-card-circle">
              {{ index + 1 }}
            </div>
            <div
              class="greetings-view__tasks-section-task-card-text"
              v-html="item.description"
            />
          </div>
        </div>
      </div>
      <div class="greetings-view-section greetings-view__link-section">
        <a
          v-for="(item, index) in linkCards"
          :key="index"
          :href="item.link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            class="greetings-view__link-section-card"
            :class="{
              'greetings-view__link-section-card--indigo': item.class === 'indigo',
              'greetings-view__link-section-card--orange': item.class === 'orange'
            }"
          >
            <div class="greetings-view__link-section-card-img">
              <img
                loading="lazy"
                :src="item.img"
              >
            </div>
            <div class="greetings-view__link-section-card-text">
              <div class="greetings-view__link-section-card-text-title">
                {{ item.title }}
              </div>
              <div class="greetings-view__link-section-card-text-description">
                {{ item.description }}
              </div>
              <div class="text-button">
                <div class="text-button__text">
                  Перейти
                </div>
                <img
                  loading="lazy"
                  src="./assets/chevron-right.svg"
                >
              </div>
            </div>
          </div>
        </a>
      </div>
      <div 
        class="
          greetings-view-section
          greetings-view__info-section
          greetings-view__support-section
        "
      >
        <div class="greetings-view__title">
          Нужна помощь? 
          <br v-if="$size.width < 500">
          Обратись в нашу поддержку
        </div>
        <a
          href="https://t.me/Likecentreadmin"
          target="_blank"
          rel="noopener noreferrer"
          class="greetings-view__support-section-link-block"
        >
          <img
            loading="lazy"
            src="./assets/telegram.svg"
          >
          @Likecentreadmin
        </a>
      </div>
      <div class="greetings-view__footer-section">
        {{ footerText }}
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  data() {
    return {
      taskCards: [
        {
          description: `
            Зайти на платформу <span class="indigo-text">Toolbox</span>
            и познакомиться с ней
          ` 
        },
        {
          description: `
            Заполнить анкету о себе 
            и своем опыте 
          `
        },
        {
          description: `
            Изучить модуль <span class="red-text">"Предобучение"</span>
            в курсах
          ` 
        },
        {
          description: `
            Заполнить анкету в папке <span class="red-text">"Сила принятого решения"</span>, 
            чтобы начать работу с коучем
          ` 
        }
      ],
      linkCards: [
        {
          title: 'Платформа',
          description: 'На платформе тебя ждут обучающие материалы и трекинг прогресса.',
          img: require('./assets/logo-like-white.svg'),
          link: config.NODE_ENV === 'production'
            ? 'https://lms.toolbox.bz'
            : 'https://lms.devtb.ru',
          class: 'indigo' 
        },
        {
          title: 'Навигатор по курсу',
          description: 'Навигатор поможет тебе соориентироваться в процессах.',
          img: require('./assets/speed-club.png'),
          link: 'https://likecentre.ru/navigator',
          class: 'orange' 
        }
      ]
    };
  },
  computed: {
    footerText () {
      return `Все права защищены ${new Date().getFullYear()} АНО «ЦРП»`;
    }
  }
};
</script>

<style lang="scss">
.wrapper {
  background: #fff !important;
}
</style>

<style scoped lang="scss">
::v-deep .red-text {
  color: #CD1919;
  font-weight: 600;
}

::v-deep .indigo-text {
  color: #5B3EF4;
  font-weight: 600;
}

.text-button {
  display: inline-flex;
  align-items: center;
  height: 18px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  transition: all 0.3s ease;

  &__text {
    margin-right: 12px;
  }

  img {
    transition: opacity 0.3s ease;
  }

  &:hover {
    margin-left: 10px;

    img {
      transition: opacity 0.3s ease;
      opacity: 0;
    }
  }
}

.greetings-view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 12px;

  img {
    max-width: unset;
  }

  &-wrapper {
    width: 100%;
    margin: 42px 100px;
    max-width: 1240px;

    @media only screen and (max-width: 700px) {
      margin: 30px 0;
    }
  }

  &__title {
    color: #37393F;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    text-transform: uppercase;
  }

  &__description {
    color: #595A5F;
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;

    @media only screen and (max-width: 700px) {
      font-size: 18px;
      line-height: 21px;
    }

    &-list {
      margin-top: 20px;
      list-style-type: initial;
      margin-left: 32px;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    margin-bottom: 48px;
    height: 40px;

    @media only screen and (max-width: 700px) {
      justify-content: center;
      margin-bottom: 30px;
    }

    &-text {
      margin-left: 16px;
      color: #37393F;
      font-weight: 400;
      font-size: 24px;
      line-height: 18px;
    }
  }

  &__banner {
    z-index: 1;
    position: relative;
    width: 100%;
    height: 460px;
    margin-bottom: 60px;
    border-radius: 16px;
    overflow: hidden;

    img {
      max-width: 100%;
    }

    &-background {
      z-index: -1;
      background: linear-gradient(
        180deg,
        #76218A 0%,
        #DC641C 48.96%,
        #DE651B 51.56%,
        #FDFCD6 100%
      );
      position: absolute;
      width: 1240px;
      height: 930px;
      left: 0px;
      top: -213px;
    }

    &-stars-img {
      position: absolute;
      width: 1166px;
      height: 306px;
      left: 42px;
      top: -24px;

      @media only screen and (max-width: 700px) {
        height: 160px;
      }
    }

    &-ship-img {
      position: absolute;
      object-fit: cover;
      bottom: -4px;
      
      @media only screen and (max-width: 500px) {
        right: 0;
        width: inherit;  
      }
    }
    
    &-text {
      position: absolute;
      top: 100px;
      left: 0;
      margin: 0 85px;
      color: #fff;

      @media only screen and (max-width: 500px) {
        left: 0;
        top: 76px;
        margin: 0 20px;
        max-width: 320px;
      }

      &-title {
        font-weight: 600;
        font-size: 40px;
        line-height: 47px;
        margin-bottom: 20px;

        @media only screen and (max-width: 700px) {
          margin-bottom: 14px;
          font-size: 24px;
          line-height: 28px;
        }
      }

      &-description {
        max-width: 525px;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;

        @media only screen and (max-width: 700px) {
          max-width: 400px;
          font-size: 18px;
          line-height: 21px;
        }
      }
    }
  }

  &-section {
    margin-bottom: 60px;

    @media only screen and (max-width: 700px) {
      margin-bottom: 30px;
    }
  }

  &__info-section {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 40px;
    background: #F3F3F3;
    border-radius: 16px;

    @media only screen and (max-width: 700px) {
      padding: 30px 20px;
    }
  }

  &__summary-section {
    &-text {
      max-width: 960px;
      text-align: center;
      
      @media only screen and (max-width: 700px) {
        font-size: 18px;
        line-height: 21px;
      }
    }
  }

  &__study-map-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    @media only screen and (max-width: 1000px) {
      flex-direction: column-reverse;
      align-items: start;
    }
        
    @media only screen and (max-width: 700px) {
      padding: 0;
    }

    &-img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 530px;
      height: 296px;
      margin-left: 38px;

      @media only screen and (max-width: 1200px) {
        width: 100%;
        height: unset;
        margin-left: 0;
        margin-bottom: 30px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        box-shadow: 0px 14px 50px rgba(12, 13, 51, 0.16);
        border-radius: 16px;
      }
    }

    &-text {
      max-width: 50%;

      @media only screen and (max-width: 1000px) {
        max-width: unset;
      }
      
      @media only screen and (max-width: 700px) {
        padding: 20px;
        padding-top: 0;
      }

      &-title {
        margin-bottom: 20px;
      }
    }
  }

  &__materials-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    @media only screen and (max-width: 700px) {
      padding: 0;
    }
        
    @media only screen and (max-width: 1000px) {
      flex-direction: column;
      align-items: start;
    }

    &-img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 600px;
      height: 340px;
      
      @media only screen and (max-width: 1200px) {
        width: 100%;
        height: unset;
        margin-left: 0;
        margin-bottom: 30px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      box-shadow: 0px 14px 50px rgba(12, 13, 51, 0.16);
      border-radius: 16px;
    }

    &-text {
      max-width: 510px;
      padding-left: 30px;

      @media only screen and (max-width: 1000px) {
        padding-left: 0;
      }

      @media only screen and (max-width: 700px) {
        padding: 20px;
        padding-top: 0;
      }

      &-title {
        margin-bottom: 20px;
      }
    }
  }

  &__tasks-section {
    display: block;
    padding: 60px 85px;
      
    @media only screen and (max-width: 700px) {
      padding: 30px 20px;
    }
    
    &-title {
      margin-bottom: 40px;  
      
      @media only screen and (max-width: 700px) {
        margin-bottom: 24px;  
      }
    }

    &-task-cards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
      gap: 20px;
      
      @media only screen and (max-width: 700px) {
        grid-template-columns: 1fr;
      }
    }

    &-task-card {
      display: flex;
      align-items: center;
      min-height: 120px;
      padding: 15px 30px;
      background: #FFFFFF;
      border-radius: 16px;
      
      @media only screen and (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        min-height: 156px;
      }

      &-circle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 60px;
        height: 60px;
        margin-right: 32px;
        color: #595A5F;
        background: #F3F3F3;
        border-radius: 80px;
        font-weight: 600;
        font-size: 40px;
        line-height: 30px;
        
        @media only screen and (max-width: 700px) {
          margin-right: 0;
          margin-bottom: 15px;
        }
      }

      &-text {
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
      }
    }
  }

  &__link-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-auto-rows: 220px;
    gap: 20px;
    
    @media only screen and (max-width: 1200px) {
      grid-template-columns: 1fr;
    }
    
    @media only screen and (max-width: 500px) {
      grid-auto-rows: 228px;
    }

    a {
      text-decoration: none;
    }

    &-card {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 50px 0;
      padding-right: 30px;
      color: #fff;
      border-radius: 16px;

      @media only screen and (max-width: 700px) {
        align-items: start;
        flex-direction: column;
        padding: 16px;
      }

      &--indigo {
        background: linear-gradient(
          102.44deg,
          #8E5FEF 5.94%,
          #5B3EF4 105.23%
        );
      }

      &--orange {
        background: linear-gradient(
          281.81deg,
          #B536D2 -62.76%,
          #DC641C 47.23%,
          #FDFCD6 174.93%
        );

        .greetings-view__link-section-card-img {
          margin-top: 40px;
          margin-left: 20px;
          margin-right: 20px;

          @media only screen and (max-width: 700px) {
            margin: 0;
            margin-left: -4px;
          }

          img {
            width: 200px;

            @media only screen and (max-width: 1200px) {
              width: 160px;
            }

            @media only screen and (max-width: 700px) {
              width: 100px;
              height: 80px;
            }
          }
        }
      }

      &-img {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 40px;

        @media only screen and (max-width: 700px) {
          margin: 0;
          margin-bottom: 20px;
        }

        img {
          @media only screen and (max-width: 700px) {
            width: 60px;
            height: 60px;
          }
        }
      }

      &-text {
        &-title {
          margin-bottom: 14px;
          font-weight: 600;
          font-size: 24px;
          line-height: 28px;
          text-transform: uppercase;
          
          @media only screen and (max-width: 700px) {
            font-size: 20px;
            line-height: 23px;
          }
        }
       
        &-description {
          margin-bottom: 34px;
          font-weight: 400;
          font-size: 20px;
          line-height: 23px;
          
          @media only screen and (max-width: 700px) {
            font-size: 18px;
            line-height: 21px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }

  &__support-section {
    flex-direction: column;
    
    @media only screen and (max-width: 500px) {
      align-items: start;
    }

    a {
      color: #595A5F;
      text-decoration: none;
    }

    &-link-block {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      padding: 20px 85px;
      background: #FFFFFF;
      color: #595A5F;
      border-radius: 8px;
      font-weight: 400;
      font-size: 20px;
      line-height: 23px;
      text-align: center;
      text-transform: uppercase;
      transition: all 0.3s ease;

      @media only screen and (max-width: 500px) {
        padding: 18px 48px;
        font-size: 18px;
        line-height: 21px;
        width: 100%;
      }

      &:hover {
        box-shadow: 0px 14px 50px rgba(0, 0, 0, 0.1);
      }

      img {
        margin-right: 16px;
      }
    }
  }

  &__footer-section {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    color: #595A5F;
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
    text-align: center;

    @media only screen and (max-width: 500px) {
      margin-bottom: 60px;
    }
  }
} 
</style>